module.exports = __webpack_public_path__ + "img/record.744b562f.png";